'use client';
import PublicOffIcon from '@mui/icons-material/PublicOff';
import { Alert, Typography } from '@mui/material';

import { useT } from '@/hooks';
import { useGeoblockStatus } from '@/services/query';

import { TOP_BANNER_HEIGHT } from '@/constants';

export const GeoBlockBanner = () => {
  const { t } = useT();
  const { data } = useGeoblockStatus();

  if (!data?.blocked) return null;

  const message = t('geoBlock.restrictedMessage', {
    location: data?.region ? `${data.country}, ${data.region}` : data?.country,
    defaultValue: `Trading is restricted in your region (${data?.country}${data?.region ? `, ${data?.region}` : ''}). Orders placed may be automatically cancelled.`,
  });

  return (
    <Alert
      icon={false}
      severity="info"
      sx={(theme) => ({
        borderRadius: 0,
        height: TOP_BANNER_HEIGHT,
        px: { xs: 2, sm: 4 },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor:
          theme.palette.mode === 'dark' ? 'rgba(59, 130, 246, 0.12)' : 'rgba(37, 99, 235, 0.08)',
        borderBottom: `1px solid ${
          theme.palette.mode === 'dark' ? 'rgba(59, 130, 246, 0.25)' : 'rgba(37, 99, 235, 0.2)'
        }`,
        backdropFilter: 'blur(8px)',
        '& .MuiAlert-message': {
          width: '100%',
          minWidth: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
          padding: 0,
        },
      })}
    >
      <PublicOffIcon
        fontSize="small"
        sx={(theme) => ({
          color: theme.palette.mode === 'dark' ? 'rgba(59, 130, 246, 0.9)' : 'primary.main',
          flexShrink: 0,
        })}
      />
      {/* Message length varies by country/region, so it can't share the streak
          banner's fixed single-line layout — keep the fixed banner height by
          truncating with an ellipsis; the full text is still available on hover
          via the native title tooltip, since this is compliance-relevant copy. */}
      <Typography
        variant="body2"
        title={message}
        sx={(theme) => ({
          fontWeight: 500,
          fontSize: { xs: '0.75rem', sm: '0.8125rem' },
          color: theme.palette.mode === 'dark' ? 'rgba(59, 130, 246, 0.95)' : 'primary.dark',
          textAlign: 'center',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          minWidth: 0,
        })}
      >
        {message}
      </Typography>
    </Alert>
  );
};

export default GeoBlockBanner;
